<template>
  <section-wrapper class="bg-background-3">
    <section-container
      mobile-padding
      class="max-w-container prose-funargos prose relative z-[1] py-20"
    >
      <!-- Titre principal H1 -->
      <div class="text-primary mb-20 text-[3rem] font-bold leading-[3.5rem]">
        CONDITIONS GENERALES D’UTILISATION DU SITE FUNARGOS
      </div>

      <!-- Sous-titre H2 -->
      <section-title class="mb-5">GENERALITES</section-title>

      <!-- Corps du texte -->
      <p>
        La structure générale du site FUNARGOS ci-après dénommé « Le Site »
        ainsi que les textes, graphiques, images, sons et vidéos le composant
        sont la propriété de la Société FUNERE ci-après dénommée « l’Editeur »
        dont les caractéristiques juridiques sont les suivantes :
      </p>
      <p>
        FUNERE SAS au capital de 45 000 €, ayant son siège social à GRENOBLE, 6
        avenue Saint-Roch – 38000, immatriculée au RCS de GRENOBLE sous le n°
        913 423 885 – Président : Louis-Baptiste VALLIN
      </p>
      <p>
        Toute représentation et/ou reproduction et/ou exploitation partielle ou
        totale des contenus et services proposés par le Site, par quelque
        procédé que ce soit, sans l’autorisation préalable et par écrit de
        l’Editeur est strictement interdite et susceptible de constituer une
        contrefaçon au sens des articles L 352-2 et suivants du Code de la
        Propriété Intellectuelle.
      </p>
      <p>
        La marque FUNARGOS est une marque déposée par l’Editeur auprès de l’INPI
        (n° enregistrement : 4906495). Toute reproduction et/ou représentation
        partielle ou totale de la marque ou de son logo de quelque nature que ce
        soit, est totalement prohibée.
      </p>
      <p>
        Le Site constitue une plateforme destinée à organiser la mise en
        relation de ses membres, tous professionnels du funéraire (« Les
        Utilisateurs »), pour leur permettre d’optimiser les flux de transport
        des corps des défunts sur tout le territoire desservi par les
        Utilisateurs et d’améliorer ainsi la rentabilité et l’efficacité de leur
        entreprise funéraire.
      </p>
      <p>
        L’Editeur n’est pas partie et n’intervient sous aucune forme dans les
        contrats de transport qui sont conclus exclusivement entre Les
        Utilisateurs.
      </p>
      <p>
        Les Utilisateurs du Site qui proposent et effectuent une prestation de
        transport sont dénommés « Utilisateurs Transporteurs ou Transporteurs ».
        Ceux qui recherchent un transport sont dénommés « Utilisateurs
        Demandeurs ou Demandeurs ».
      </p>
      <p>
        Pour l’utilisation du site, Les Utilisateurs ont l’obligation de se
        conformer aux présentes conditions générales d’utilisation (« CGU »)
        qu’ils devront accepter sans réserve.
      </p>
      <p>
        Cette acceptation constitue une condition préalable à l’ouverture d’un
        compte utilisateur et à la connexion au site.
      </p>
      <p>
        L’Editeur se réserve la possibilité de modifier, à tout moment et sans
        préavis, les présentes conditions d’utilisation afin de les adapter à
        l’évolution technique ou commercial du Site ou de son exploitation et à
        toutes modifications légales ou règlementaires pouvant toucher
        l’économie numérique ou l’activité funéraire.
      </p>

      <!-- Autres sous-titres et paragraphes suivent de la même manière -->
      <section-title class="mb-5">PARTENAIRES DE FUNARGOS</section-title>
      <ul>
        <li>
          Concernant la gestion de l’ensemble des flux financiers générés par le
          Site, L’Editeur a choisi la Société STRIPE, spécialiste mondialement
          reconnu dans la sécurisation des paiements en ligne.
        </li>
        <li>L’hébergement du site a été confié à la Société OVH.</li>
      </ul>

      <section-title class="mb-5"
        >CONDITIONS POUR DEVENIR UTILISATEUR</section-title
      >
      <p>
        Ne peuvent utiliser le site, que les opérateurs funéraires habilités en
        préfecture de France métropolitaine, titulaires d’un compte ouvert sur
        le site.
      </p>
      <p>
        Seuls pourront disposer d’un compte, les opérateurs funéraires habilités
        :
      </p>
      <ul>
        <li>
          régulièrement immatriculés et disposant de toutes les autorisations
          nécessaires délivrées par les autorités concernées et notamment de
          l’autorisation préfectorale funéraire.
        </li>
        <li>
          dont la candidature aura été préalablement validée par l’Editeur au
          vue des documents produits par le candidat utilisateur
        </li>
        <li>ayant souscrit un référencement gratuit sur le site</li>
        <li>
          ayant préalablement accepté les présentes conditions générales
          d’utilisation.
        </li>
      </ul>
      <p>
        Chaque utilisateur disposera d’un espace dédié lui permettant de gérer
        les contrats dont il est partie avec un historique des opérations
        réalisées.
      </p>
      <!-- Section RESPONSABILITE DE L’EDITEUR -->
      <section-title class="mb-5">RESPONSABILITE DE L’EDITEUR</section-title>
      <h3 class="text-primary">Accès au service</h3>
      <p>
        L’Editeur s’efforce de permettre l’accès au site 24 heures sur 24, 7
        jours sur 7 sauf en cas de force majeure ou cas fortuit ou d’un
        évènement hors de contrôle de l’Editeur et sous réserve des éventuelles
        pannes et des interventions de maintenance nécessaires au bon
        fonctionnement du site et de ses services et aux modifications
        techniques apportées au site.
      </p>
      <p>
        Sont considérés comme cas de force majeure ou cas fortuits définis par
        l’article 1148 du Code Civil outre ceux habituellement retenus par la
        jurisprudence des cours et des tribunaux Français, les conflits sociaux,
        les pandémies, les défaillances internes ou externes du réseau et du
        serveur d’hébergement.
      </p>

      <h3 class="text-primary">
        Informations et données transmises et/ou consultées par les Utilisateurs
      </h3>
      <p>
        L’Utilisateur est et demeurera seul responsable de l’usage des données
        qu’il consulte, interroge et transfert sur le site. La communication de
        toute information jugée par l’Utilisateur comme sensible ou
        confidentielle se fait à ses risques et périls.
      </p>
      <p>
        L’Utilisateur reconnaît que l’Editeur n’est pas en mesure d’exercer un
        contrôle sur la validité ou l’exactitude des informations qui pourraient
        transiter sur son site. L’utilisation des informations disponibles sur
        ce site se fait sous l’entière responsabilité des Utilisateurs, qui
        assument la totalité des conséquences pouvant en découler sans que
        l’Editeur puisse être recherché à ce titre et sans aucun recours contre
        ce dernier.
      </p>
      <p>
        L’Editeur ne pourra en aucun cas être tenu responsable de tout dommage
        de quelque nature qu’il soit résultant de l’interprétation ou de
        l’utilisation des informations disponibles sur le site.
      </p>

      <h3 class="text-primary">Contrats de transport</h3>
      <p>
        Comme indiqué ci-dessus, L’Editeur n’intervient pas dans les accords
        commerciaux conclus entre Les Utilisateurs et à ce titre est exclu de
        toute responsabilité pouvant découler d’une information erronée ou
        incomplète d’un Utilisateur ou d’une mauvaise exécution du contrat de
        transport quelle qu’en soit la cause. L’Editeur n’approuve, ne soutient
        ni ne garantit d’aucune manière l’authenticité, l’exactitude ou la
        fiabilité des informations contenues dans les annonces du site.
        L’Editeur ne fournit aucune protection en matière d’assurance en
        responsabilité civile et n’intervient pas en qualité d’arbitre en cas de
        litige entre Utilisateurs.
      </p>

      <!-- Section OBLIGATIONS CONTRACTUELLES DES UTILISATEURS -->
      <section-title class="mb-5"
        >OBLIGATIONS CONTRACTUELLES DES UTILISATEURS</section-title
      >
      <h3 class="text-primary">A l’égard de l’Editeur</h3>
      <p>
        L’Utilisateur ne pourra utiliser le site ou les outils et services
        disponibles sur le site à des fins autres que celles autorisées par les
        présentes CGU ou pour effectuer des opérations autres que celles
        proposées sur le site.
      </p>
      <p>
        Il veillera à ne rien publier sur le site qui soit en infraction avec la
        législation ou inciter un tiers à commettre une telle infraction. Il
        s’interdit formellement :
      </p>
      <ul>
        <li>
          d’afficher ou transmettre des informations qui sont, de quelque
          manière que ce soit, fausses, frauduleuses, trompeuses, illégales ou
          dont le contenu présente un caractère menaçant, abusif, injurieux,
          diffamatoire, indécent.
        </li>
        <li>
          de faire croire que l’Editeur approuve, cautionne, ou agit en qualité
          de partenaire de l’Utilisateur.
        </li>
      </ul>
      <p>
        L’Editeur se réserve le droit de supprimer toutes informations
        contrevenant aux dispositions précitées, de suspendre momentanément le
        compte de l’Utilisateur fautif ou en cas de manquements graves ou
        répétés, d’exclure définitivement ledit Utilisateur. En outre, si le
        comportement de l’Utilisateur porte atteinte aux intérêts même de
        l’Editeur, ce dernier se réserve d’intenter à son égard auprès des
        Tribunaux compétents une action en demande de dommages et intérêts en
        réparation du préjudice qu’il aura subi.
      </p>

      <h3 class="text-primary">Entre Utilisateurs</h3>
      <p>
        Les Utilisateurs se doivent de préciser les conditions de l’offre et/ou
        de la demande de transport et de donner toutes informations utiles et
        nécessaires au consentement de bonne foi et éclairé des parties au
        contrat de transport.
      </p>
      <p>
        L’Utilisateur Transporteur veillera à la bonne exécution du contrat
        conformément au cahier des charges accepté par les parties (date et
        horaire du transport, lieux de départ et d’arrivée, type de transport,
        opération effectuée avant ou après mise en bière…)
      </p>
      <p>
        Tout Utilisateur Transporteur ayant conclu un accord sur le transport
        d’un corps ne pourra se rétracter sauf accord exprès de l’autre partie
        contractante (Utilisateur Demandeur) ou cas de force majeure. Dans tous
        les cas, les frais de service de l’Editeur relatif à l’opération annulée
        par l’Utisateur Demandeur resteront exclusivement à sa charge.
      </p>
      <p>
        Les Utilisateurs contractants feront leur affaire personnelle des
        éventuels dommages pouvant résulter d’une mauvaise exécution du
        transport ou de renseignements erronés ou incomplets transmis par un
        Utilisateur Demandeur.
      </p>

      <!-- Section CONFIDENTIALITE ET PROTECTION DES DONNEES PERSONNELLES -->
      <section-title class="mb-5"
        >CONFIDENTIALITE ET PROTECTION DES DONNEES PERSONNELLES</section-title
      >
      <p>
        Conformément à la réglementation en vigueur, FUNERE a mis en place une
        politique de protection de vos données à caractère personnel. Nous vous
        invitons à la consulter directement sur notre site web ou à l’adresse
        suivante :
        <a href="http://funargos.fr/politique-de-confidentialite"
          >http://funargos.fr/politique-de-confidentialite</a
        >
        Pour tout question, vous pouvez vous adresser à :
        <a href="mailto:privacy@funargos.fr">privacy@funargos.fr </a>
      </p>
      <!-- Section LITIGES -->
      <section-title class="mb-5">LITIGES</section-title>
      <p>
        La résolution des litiges entre l’Editeur et les Utilisateurs découlant
        de l’interprétation, l’application ou l’exécution des présentes CGU, à
        défaut d’accord amiable entre les parties, est du ressort exclusif des
        Tribunaux de GRENOBLE.
      </p>

      <!-- Section DROIT APPLICABLE -->
      <section-title class="mb-5">DROIT APPLICABLE</section-title>
      <p>
        Les droits et obligations résultant des présentes CGU sont exclusivement
        régis et interprétés conformément au droit français, quelles que soient
        la nationalité des utilisateurs et le lieu d’exécution des contrats de
        transport.
      </p>
    </section-container>
  </section-wrapper>
</template>
<script setup></script>
